import { useRef } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import HowItWorks from "@/components/site/HowItWorks";
import Plans from "@/components/site/Plans";
import CoreSubjects from "@/components/site/CoreSubjects";
import AdditionalCourses from "@/components/site/AdditionalCourses";
import Manifesto from "@/components/site/Manifesto";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import DemoForm from "@/components/site/DemoForm";
import Footer from "@/components/site/Footer";
import { scrollToId } from "@/lib/site";

export default function Home() {
  const scrollTo = (id) => scrollToId(id);

  return (
    <div className="bg-background overflow-x-hidden">
      <Nav />
      <Hero onDemo={() => scrollTo("#demo")} onPlans={() => scrollTo("#plans")} />
      <Ribbon />
      <HowItWorks />
      <Plans />
      <CoreSubjects />
      <AdditionalCourses />
      <Manifesto />
      <Testimonials />
      <FAQ />
      <DemoForm />
      <Footer />
    </div>
  );
}
